import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import useStyles from '@front10/helpers/dist/UseStyles';
import { Context } from '@front10/helpers/dist/Context';
import Box from '../../elements/Box';

const DatePickerDay = (props) => {
  const { day } = props;
  const date = day.getDate();
  const { direction, theme } = useContext(Context);
  const [className, style] = useStyles(props, { direction, theme });
  return (
    <Box className={className} dataTestId="DatepickerDay" style={style}>
      {date}
    </Box>
  );
};
DatePickerDay.propTypes = {
  /**
   * Day to show
   */
  day: PropTypes.objectOf(PropTypes.any).isRequired,
};

DatePickerDay.defaultProps = {};
export default DatePickerDay;
